import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/authentication/auth.service';
import type { PermissionCode } from 'src/app/core/constants/permissions';

export const permissionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const appService = inject(AppService);
  const router = inject(Router);

  const requiredPermission = route.data['permission'] as
    | PermissionCode
    | PermissionCode[]
    | undefined;

  if (!requiredPermission) {
    // If no permission restriction, allow access
    return true;
  }

  const codes = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];

  if (authService.canAny(...codes)) {
    return true;
  }

  appService.makeWarningToast('Access Denied', 'You do not have permission to access this page.');
  router.navigate(['/home']);
  return false;
};
